const React = require('react')
const { useState, useEffect } = require('react')
const { useParams } = require('react-router-dom')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { TableHeader, TableFooterWithoutLimit } = require('@components/table')

const { TokenHoldersTable } = require('./holdersTable.token')

require('@styles/pages/address/transactions.address.css')

const TokenHolders = props => {
    const { data } = props
    const { address } = useParams()
    const { network } = useNetworkConfig()
    const params = new URLSearchParams(location.search)

    const { getTokenHolders } = useBlockchainData(network.name)

    const [loading, setLoading] = useState(false)
    const [tokenHoldersData, setTokenHoldersData] = useState()
    const [page, setPage] = useState(Number(params.get('p')) || 1)

    const [totalPages, setTotalPages] = useState(0)

    const [title, setTitle] = useState()
    const [subtitle, setSubtitle] = useState()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const pageParam = Number(params.get('p'))

        if (pageParam && pageParam > 0 && pageParam !== page) {
            setPage(pageParam)
        }
    }, [location.search])

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)

                const [tokenHoldersResponse] = await Promise.all([getTokenHolders(address, page, 50)])

                if (tokenHoldersResponse) {
                    setTokenHoldersData(tokenHoldersResponse)

                    setTitle(`More than ${tokenHoldersResponse?.totalItems.toLocaleString()} transactions found`)
                    setSubtitle(
                        tokenHoldersResponse?.totalItems > 10_000 ? 'Showing the last 10_000 transactions' : undefined
                    )
                    setTotalPages(
                        tokenHoldersResponse.totalItems > 10_000 ? 10_000 / 25 : tokenHoldersResponse.totalPages
                    )
                }

                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error)
                setLoading(false)
            }
        }
        fetchData()
    }, [address, network, page])

    return (
        <div className='box table-section' style={{ paddingTop: !tokenHoldersData?.totalItems ? 0 : undefined }}>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    {tokenHoldersData?.totalItems == 0 ? (
                        <>
                            <TokenHoldersTable data={tokenHoldersData?.items} overviewData={data} />
                        </>
                    ) : (
                        <>
                            <TableHeader
                                title={title}
                                subtitle={subtitle}
                                page={page}
                                limit={25}
                                totalPages={totalPages}
                            />
                            <TokenHoldersTable data={tokenHoldersData?.items} overviewData={data} />
                            <TableFooterWithoutLimit page={page} limit={25} totalPages={totalPages} />
                        </>
                    )}
                </>
            )}
        </div>
    )
}

module.exports = { TokenHolders }
